import { css } from 'linaria';

export const menu = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: var(--space-300);
  padding: var(--space-200) 0 var(--space-275);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
`;

export const mobileScrolling = css`
  overflow: visible;
  overflow-y: scroll;
`;

export const item = css`
  text-wrap: nowrap;

  &[data-testid='button']:hover {
    background-color: unset !important;
    box-shadow: none !important;
    color: var(--brand-dark) !important;
  }

  > img {
    margin-right: var(--space-100);
  }
`;

export const shadowBackground = css`
  height: var(--space-300);
  background: linear-gradient(180deg, rgba(70, 76, 92, 0.04) 0%, rgba(255, 255, 255, 0) 100%);
`;
